import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";
import { DATE_TIME_RANGE_PICKER_SHORTCUTS } from "@/constant/system/options";

export const formItems = [
  createFormItem(
    '执行时间', 
    'runTimes', 
    FORM_ITEM.DATE_PICKER, 
    {
      type: 'datetimerange',
      rangeSeparator: '至',
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      shortcuts: DATE_TIME_RANGE_PICKER_SHORTCUTS
    }
  ),
  createFormItem(
    '执行结果', 
    'executionResult', 
    FORM_ITEM.SELECT, 
    {
      loader: 'JOB_RUN_RESULT',
      allOption: true,
      default: true,
      defaultOnNull: true
    }
  )
]